import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorCreditItemsBus } from "./VendorCreditItemsBus";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";
import * as _ from 'lodash';
 export class VendorCreditBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
         this.creditDate = DateFunctions.getDate(this.creditDate);
         this.sageDt = DateFunctions.getDate(this.sageDt);
     }

     CID(): any {
         return this.vendorCreditId;
     }
     setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
         this.companyId = companyId;
         //this.creditDate = DateFunctions.getDateOnly(date);
         //this.vendorCreditStatusId = CommonValues.VendorCredit_StatusReceived;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
         if (CommonFunctions.hasArrayElementValue(this.vendorCreditItems)) {
             for (let i = 0; i < this.vendorCreditItems.length; i++) {
                 this.vendorCreditItems[i].setCommon(userId, date, companyId, personId);
                 if (!DateFunctions.isValidDate(this.vendorCreditItems[i].insertDt)) {
                     this.vendorCreditItems[i].insertDt = date;
                     this.vendorCreditItems[i].insertUserId = userId;
                 }
                 if (!DateFunctions.isValidDate(this.vendorCreditItems[i].updateDt)) {
                     this.vendorCreditItems[i].updateDt = date;
                     this.vendorCreditItems[i].updateUserId = userId;
                 }
             }
         }
     }
     addItem(data: VendorCreditItemsBus) {
         if (!CommonFunctions.hasArrayValue(this.vendorCreditItems)) {
             this.vendorCreditItems = [];
         }
         let exists: boolean = false;
         for (let i = 0; i < this.vendorCreditItems.length; i++) {
             if (this.vendorCreditItems[i].inventoryId === data.inventoryId
                 && this.vendorCreditItems[i].invDesc === data.invDesc
                 && this.vendorCreditItems[i].classId === data.classId
                 && this.vendorCreditItems[i].cost  === data.cost) {
                 this.vendorCreditItems[i].quantity += data.quantity;
                 exists = true;
                 break;
             }
         }
         if (!exists) {
             this.vendorCreditItems.push(data);
             this.vendorCreditItems = _.cloneDeep(this.vendorCreditItems)
         }
     }
     isValid(): boolean {
         return DateFunctions.isValidDate(this.creditDate)
             && CommonFunctions.hasGuidValue(this.supplierId)
             && CommonFunctions.hasStringValue(this.refNo)
             && CommonFunctions.hasGuidValue(this.vendorCreditStatusId)
             ? true : false;
     }
     get inFinance(): boolean {
         return DateFunctions.isValidDate(this.sageDt);
     }
     setBeforeSave() {
         this.creditDate = DateFunctions.getDateWithUTCOffset(this.creditDate);
         this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
     }
     vendorCreditId: any;
     orderBillId: any;
 companyId: any;
 supplierId: any;
 creditDate: Date;
 refNo: string;
 memo: string;
 credit: number ;
 vendorCreditStatusId: any;
 qbid: string;
 qbeditSequenceId: string;
 insertDt: Date ;
 insertUserId: any;
 updateDt: Date ;
 updateUserId: any;
 sageDt: Date ;
 vendorCreditItems: VendorCreditItemsBus[];
     oicInvoiceId: string;
     canNotCreateCreditReason: string;
     orderId: string;
     invoiceId: string;
     invoiceNumber: string;
 }
